/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosEnumResellerContinents } from "@cosmos/hygraph-schema";

export type FilterItem = {
	id: string;
	label: string;
};

export const ContinentList = [...Object.values(CosmosEnumResellerContinents)];
export const getUniqueContinents = (items: Partial<{ continents?: string[] | null }>[]): string[] => {
	if (!items?.length) return [];

	const uniqueSet = new Set<string>();

	for (const item of items) {
		if (!item?.continents?.length) continue;

		item?.continents.forEach((continent) => {
			if (continent && !uniqueSet.has(continent)) {
				uniqueSet.add(continent);
			}
		});

		if (uniqueSet.size === ContinentList.length) {
			return ContinentList;
		}
	}

	return ContinentList.filter(Boolean).filter((item) => uniqueSet.has(item));
};
